import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GuidelinesComponent } from './guidelines/guidelines.component';
import { HomeComponent } from './home/home.component';
import { IntroComponent } from './intro/intro.component';
import { LayoutComponent } from './layout/layout.component';
import { PanadolExtraComponent } from './panadol-extra/panadol-extra.component';
import { PanadolKidsComponent } from './panadol-kids/panadol-kids.component';
import { PanadolComponent } from './panadol/panadol.component';
import { ReferenceComponent } from './reference/reference.component';
import { SuitabilityComponent } from './suitability/suitability.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  {
    path: 'page',
    component: LayoutComponent,
    children: [
      { path: 'home', component: HomeComponent },
      { path: 'intro', component: IntroComponent },
      { path: 'panadol', component: PanadolComponent },
      { path: 'panadol-extra', component: PanadolExtraComponent },
      { path: 'panadol-kids', component: PanadolKidsComponent },
      { path: 'guidelines', component: GuidelinesComponent },
      { path: 'suitability', component: SuitabilityComponent },
      { path: 'reference', component: ReferenceComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
